"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", Object.assign({ fill: "none" }, props),
        React.createElement("path", { d: "M13.47 1.59C13.7627 1.29729 13.7627 0.822711 13.47 0.53C13.1773 0.237289 12.7027 0.237289 12.41 0.53L7 5.94L1.59 0.53C1.29729 0.237289 0.822711 0.237289 0.53 0.53C0.237289 0.822711 0.237289 1.29729 0.53 1.59L5.94 7L0.53 12.41C0.237289 12.7027 0.237289 13.1773 0.53 13.47C0.822711 13.7627 1.29729 13.7627 1.59 13.47L7 8.06L12.41 13.47C12.7027 13.7627 13.1773 13.7627 13.47 13.47C13.7627 13.1773 13.7627 12.7027 13.47 12.41L8.06 7L13.47 1.59Z", fill: "#36354C" }))));
exports.default = SVGComponent;
//# sourceMappingURL=cross-icon.js.map